import { memo } from 'react';
import { ItemList } from 'schema-dts';
import Head from 'next/head';

import { SEO_FALLBACK_IMAGE } from '@mais-retorno-front/constants/mais-retorno-description';
import { SEO_SCHEMA_BASE } from '@mais-retorno-front/models/seo';

type IItemListSchemaProps = {
  listItems: { url: string; name: string }[];
} & Partial<ItemList>;

/**
 * Use this component to set ItemList schema in pages
 * Use this in <Head> Next component
 * ItemList Schema -> https://schema.org/ItemList
 * @Props props https://schema.org/ItemList
 * @returns ItemList Schema script
 */
export const ItemListSchema = memo<IItemListSchemaProps>(
  ({
    url,
    name,
    description,
    image = SEO_FALLBACK_IMAGE,
    listItems,
    ...props
  }) => {
    const schema: ItemList & SEO_SCHEMA_BASE = {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name,
      description,
      url,
      image,
      numberOfItems: listItems.length,
      itemListElement: listItems.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: { '@id': item.url, name: item.name },
      })),
      ...props,
    };

    return (
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      </Head>
    );
  }
);
